import styled from "styled-components";

export const Container = styled.div`
    width: calc(100% - 18.75rem);
    min-height: 100vh;
    background-size: cover;
    background: linear-gradient(213.35deg, #CC2A55 21.32%, #BE1622 93.04%);
    background-size: fixed;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: "Montserrat", sans-serif;
    align-items: center;
    overflow: hidden;
    padding-left: 18.75rem; // Sidebar size

    .image-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding-bottom: 25rem;

        img {
            height: auto;
            width: auto;
            max-height: 65vh;
            max-width: 60vw;
            border-radius: 1.5rem;
            margin: 5rem 0
        }
    }

    .about {
        position: flex;
        width: 32rem;
        height: 20rem;
        bottom: 10rem;
        background-color: white;
        padding: 1rem;
        border-radius: .8rem;
        text-align: center;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;

        ::-webkit-scrollbar {
            display: none;
        }


        h1 {
            font-style: italic;
            font-weight: 800;
            font-size: 2rem;
            margin-bottom: 2rem;
        }

        p {
            font-size: 1rem;
            font-weight: 500;
            color: #575F6E;
            margin: 1rem;
        }

        span {
            font-weight: bold;
            color: black;
        }
    }

    .buttons {
        width: 32rem;
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 1rem;
    }

    a {
        text-decoration: none;
    }

    .button {
        width: 15rem;
        padding: 1rem 0;
        display: flex;
        justify-content: center;
        color: white;
        border-radius: .25rem;
        text-decoration: none;
        font-size: 1.125rem;
        font-weight: normal;
        background-color: #F56D6D;
    }

    form {
        position: absolute;
        bottom: 5rem;
        width: 32rem;
        display: flex;
        justify-content: space-between;

        Input {
            width: 20rem;
            border: 1px solid #F56D6D;
        }

        Button {
            background-color: #007AFF;
        }
    }

    @media (max-width: 1300px) {
        padding-left: unset;
        width: 100%;
    }

    @media (max-width: 576px) {
        .about, .button {
            width: 80vw;
        }
    }
`